/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { AssignCompaniesRole } from "./AssignCompaniesRole";
import {
  AssignCompaniesRoleFromJSON,
  AssignCompaniesRoleFromJSONTyped,
  AssignCompaniesRoleToJSON,
  AssignCompaniesRoleToJSONTyped,
} from "./AssignCompaniesRole";

/**
 *
 * @export
 * @interface AssignCompaniesInput
 */
export interface AssignCompaniesInput {
  /**
   *
   * @type {Array<string>}
   * @memberof AssignCompaniesInput
   */
  companyIds: Array<string>;
  /**
   *
   * @type {string}
   * @memberof AssignCompaniesInput
   */
  assignedTo?: string | null;
  /**
   *
   * @type {AssignCompaniesRole}
   * @memberof AssignCompaniesInput
   */
  role: AssignCompaniesRole;
}

/**
 * Check if a given object implements the AssignCompaniesInput interface.
 */
export function instanceOfAssignCompaniesInput(
  value: object,
): value is AssignCompaniesInput {
  if (!("companyIds" in value) || value["companyIds"] === undefined)
    return false;
  if (!("role" in value) || value["role"] === undefined) return false;
  return true;
}

export function AssignCompaniesInputFromJSON(json: any): AssignCompaniesInput {
  return AssignCompaniesInputFromJSONTyped(json, false);
}

export function AssignCompaniesInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AssignCompaniesInput {
  if (json == null) {
    return json;
  }
  return {
    companyIds: json["companyIds"],
    assignedTo: json["assignedTo"] == null ? undefined : json["assignedTo"],
    role: AssignCompaniesRoleFromJSON(json["role"]),
  };
}

export function AssignCompaniesInputToJSON(json: any): AssignCompaniesInput {
  return AssignCompaniesInputToJSONTyped(json, false);
}

export function AssignCompaniesInputToJSONTyped(
  value?: AssignCompaniesInput | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyIds: value["companyIds"],
    assignedTo: value["assignedTo"],
    role: AssignCompaniesRoleToJSON(value["role"]),
  };
}
